import { LOCATION_CHANGE } from 'connected-react-router'
import { ofType } from 'redux-observable'
import { setLanguage } from 'redux-polyglot'
import { of } from 'rxjs'
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators'
import { translationsCall } from 'api/planet/translations'
import { hasNoCypher } from 'domain/router'
import { getPartner, getURILocale, getURIPartner } from 'store/selectors'

export default (actions$, state$) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  filter(hasNoCypher),
  map(() => getURILocale(state$.value)),
  distinctUntilChanged(),
  switchMap(locale => {
    const partner = getPartner(state$.value) || getURIPartner(state$.value)

    return translationsCall(locale, partner).pipe(
      switchMap(({ response }) => (
        of(setLanguage(locale, response))
      ))
    )
  })
)
